import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Bar Cabrero — C. Julián Ceballos 19, Torrelavega
const COORDS = [43.34920, -4.04680];
const ZOOM = 16;

export default function MapEmbed() {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !elRef.current) return;

    const map = L.map(elRef.current, {
      center: COORDS,
      zoom: ZOOM,
      zoomControl: true,
      scrollWheelZoom: false,
      attributionControl: true,
    });
    mapRef.current = map;

    // Carto Positron — light style
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20,
    }).addTo(map);

    // Custom amber marker
    const icon = L.divIcon({
      className: 'cabrero-marker',
      html: `
        <div class="cm-pin">
          <div class="cm-pulse"></div>
          <div class="cm-dot"></div>
        </div>
      `,
      iconSize: [28, 28],
      iconAnchor: [14, 14],
    });

    L.marker(COORDS, { icon })
      .addTo(map)
      .bindPopup(
        '<div style="font-family: \'DM Sans\', sans-serif; min-width:160px;">' +
        '<strong style="font-family: \'Playfair Display\', serif; color:#1E2B22;">Bar Cabrero</strong><br/>' +
        '<span style="color:#5C6B61; font-size:0.85rem;">C. Julián Ceballos 19<br/>Torrelavega · Cantabria</span>' +
        '</div>'
      );

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, []);

  return (
    <div
      ref={elRef}
      data-testid="map-embed"
      role="img"
      aria-label="Mapa Bar Cabrero — C. Julián Ceballos 19, Torrelavega"
      style={{ width: '100%', height: '100%', minHeight: 380, borderRadius: 'var(--r)' }}
    />
  );
}
